import styled from 'styled-components';

export const Modal = styled.article`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  /* align-items: flex-end; */
  justify-content: flex-end;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 7;
`;

export const Container = styled.section`
  width: 100%;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  padding: 28px 12px;
  gap: 20px;
  background-color: ${({ theme }) => theme.colors.grey[700]};
  border: 4px solid ${({ theme }) => theme.colors.grey[800]};
  color: ${({ theme }) => theme.colors.grey.white};
  border-radius: 12px 0 0 12px;
`;

export const Title = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    font-family: 'Bebas Neue', sans-serif;
    margin-bottom: -6px;
  }
`;

export const ButtonClose = styled.button`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey.white};
  background-color: transparent;
  border: 0;

  svg {
    width: 32px;
    height: 32px;
    transform: rotate(45deg);
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > div {
    display: flex;
    flex-direction: column;

    p {
      font-size: 20px;
    }

    div {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 8px;

      input {
        padding: 4px;
        font-size: 16px;
      }
    }
  }
`;

export const Plans = styled.div`
  width: 100%;
  padding: 0px 8px 8px 8px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.primary.dark};
  gap: 16px;
  background-color: ${({ theme }) => theme.colors.grey[800]};
`;

export const PlanHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    display: flex;
    background-color: transparent;
    border: 0;

    svg {
      color: ${({ theme }) => theme.colors.grey.white};
    }
  }
`;

export const PlanTitle = styled.div`
  display: flex;
  align-items: flex-end !important;

  h2 {
    font-family: 'ANTON', sans-serif;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    margin-bottom: -8px;
  }

  h4 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    margin-bottom: -4px;
  }
`;

export const PlanInfo = styled.div`
  display: flex;
  align-items: center;

  button {
    width: 100%;
    padding: 6px 8px;
    margin-top: -16px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.primary.dark};
    background-color: transparent;
    color: ${({ theme }) => theme.colors.grey.white};

    p {
      margin-bottom: -4px;
    }

    &:nth-child(${({ $select }) => $select}) {
      background-color: ${({ theme }) => theme.colors.primary.main};
    }
  }
`;

export const PlanQuantity = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.grey.white};
  border-radius: 8px;
  overflow: hidden;

  button {
    display: flex;
    background-color: transparent;
    padding: 8px;
    border: 0;
    border-right: 1px solid ${({ theme }) => theme.colors.grey.white};
    background-color: ${({ theme }) => theme.colors.grey[600]};
    color: ${({ theme }) => theme.colors.grey.white};

    &:nth-last-child(1) {
      border-right: 0;
      border-left: 1px solid ${({ theme }) => theme.colors.grey.white};
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }

  p {
    padding: 0 8px;
    margin-bottom: -4px;
  }
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: auto;

  button {
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    border: 0;
    background-color: ${({ theme }) => theme.colors.primary.main};
    color: ${({ theme }) => theme.colors.grey.white};
    text-transform: uppercase;

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;
